import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import './Navbar.css';

interface NavbarProps {
  isAuthenticated: boolean;
  onLogout: () => void;
  userName?: string;
}

const Navbar: React.FC<NavbarProps> = ({ isAuthenticated, onLogout, userName }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">Ak</span>
          <span className="logo-text">Akountant</span>
        </Link>

        {/* Desktop: Auth buttons or User menu */}
        {!isAuthenticated ? (
          <div className="navbar-auth-buttons">
            <Link to="/auth" className="btn-nav-login">Log In</Link>
            <Link to="/auth" className="btn-nav-signup">Sign Up</Link>
          </div>
        ) : (
          <div className="navbar-user-menu">
            <span className="welcome-text">Welcome, {userName}</span>
            <Link to="/dashboard" className="btn-dashboard">Dashboard</Link>
            <button onClick={onLogout} className="btn-logout">Log Out</button>
          </div>
        )}

        {/* Mobile menu toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          {!isAuthenticated ? (
            <div className="mobile-login">
              <Link to="/auth" className="btn-mobile-login" onClick={() => setMobileMenuOpen(false)}>
                Log In
              </Link>
              <Link to="/auth" className="btn-mobile-signup" onClick={() => setMobileMenuOpen(false)}>
                Sign Up
              </Link>
            </div>
          ) : (
            <div className="mobile-user-menu">
              <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
              <button onClick={() => { onLogout(); setMobileMenuOpen(false); }}>Log Out</button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
